import {
  MOON_500,
  MOON_650,
  MOON_950,
} from '@wandb/weave/common/css/globals.styles';
// eslint-disable-next-line wandb/no-deprecated-imports
import styled from 'styled-components';

export const AutomaticClearMessage = styled.div`
  text-align: right;
  font-size: 14px;
  line-height: 24px;
  margin: 16px 0;
  color: ${MOON_500};
`;
AutomaticClearMessage.displayName = 'S.AutomaticClearMessage';

export const EmptyQueueTitle = styled.div`
  text-align: center;
  font-weight: 600;
  font-size: 20px;
  line-height: 28px;
  color: ${MOON_950};
  margin-top: 64px;
`;
EmptyQueueTitle.displayName = 'S.EmptyQueueTitle';

export const EmptyQueueMessage = styled.div`
  text-align: center;
  color: ${MOON_650};
  margin-top: 8px;
`;
EmptyQueueMessage.displayName = 'S.EmptyQueueMessage';
